import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import Trash from 'react-feather/dist/icons/trash.js';
import Edit from 'react-feather/dist/icons/edit.js';

import CommentsModal from '../../components/Modals/CommentsModal/CommentsModal.jsx';
import Date from '../../../shared/components/Moment/Date.jsx';

import connectModal from '../../../shared/components/Modals/connect.js';
import {isAdmin} from '../../../shared/services/userService.js';

import './Notes.scss';

class Notes extends PureComponent {
  renderNote = (note) => {
    const dates = [{key: 'createdAt', prefix: 'Créé le', value: note.created_at}];
    if (note.updated_at !== note.created_at) {
      dates.push({key: 'updatedAt', prefix: 'Mis à jour le', value: note.updated_at});
    }

    return <div key={note.id} className="note bd-gray-200 col-md-12">
      <div className="note-header d-flex align-items-center justify-content-between">
        <div className="infos d-flex align-items-center">
          <p className="author mb-0">
            {note?.author.firstname ?? ''} {note?.author.lastname ?? ''}
          </p>
          <p className="dates">
            {dates
              .map(date => (
                <Fragment key={date.key}>{date.prefix} <Date format="dd/MM/yyyy \à HH:mm" date={date.value}/></Fragment>
              ))
              .reduce((prev, curr) => [prev, ' - ', curr])
            }
          </p>
        </div>
        <div className="actions d-flex">
          {this.props.onEdit ?
            <div onClick={() => this.props.onEdit(note)} className="btn btn btn-outline-primary btn-round">
              <Edit/>
            </div> : ''
          }
          {this.props.isAdmin && this.props.onDelete ?
            <div onClick={() => this.props.onDelete(note.id)} className="btn btn btn-outline-danger btn-round">
              <Trash/>
            </div> : ''
          }
        </div>
      </div>
      <p className="comment bg-gray-100" dangerouslySetInnerHTML={{__html: note.comment}}/>
    </div>;
  };

  render() {
    const {notes} = this.props;

    const children = notes.length === 0 ?
      <div className="font-italic">Aucun commentaire</div> :
      notes.map(note => this.renderNote(note))
    ;

    return <div className="notes row justify-content-center my-3 mx-0">{children}</div>;
  }
}

export default connect(
  (state) => ({
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(connectModal({CommentsModal}, Notes));